"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    Object.defineProperty(o, k2, { enumerable: true, get: function() { return m[k]; } });
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var design_language_1 = require("@doordash/design-language");
var React = __importStar(require("react"));
var App_1 = require("../../App");
var enums_1 = require("../../Common/utils/enums");
var MfaBlocked_1 = __importDefault(require("../components/MfaBlocked"));
var ImpressionTracker_1 = __importDefault(require("../Tracking/ImpressionTracker"));
var VerifyAccountContext_1 = __importDefault(require("../VerifyAccountContext"));
var VerifyAccountStyles_1 = require("../VerifyAccountStyles");
var VerifyAccountTracking_1 = require("../VerifyAccountTracking");
var VerifyPasscode_1 = __importDefault(require("../VerifyPasscode"));
var PhoneEmailVerificationStrings_1 = __importDefault(require("./PhoneEmailVerificationStrings"));
var PhoneEmailVerifyContent = function () {
    var state = React.useContext(App_1.RiskContext).state;
    var mfaState = React.useContext(VerifyAccountContext_1["default"]).mfaState;
    return (React.createElement(VerifyAccountStyles_1.Root, null,
        React.createElement(VerifyAccountStyles_1.VerifyAccountContainer, null,
            React.createElement(design_language_1.StackChildren, null, mfaState === enums_1.MfaStates.Blocked ? (React.createElement(MfaBlocked_1["default"], null)) : (React.createElement(ImpressionTracker_1["default"], { onImpression: function () { return VerifyAccountTracking_1.trackChallengeTrigger(state.workflow); } },
                React.createElement(VerifyPasscode_1["default"]
                // tslint:disable-next-line:max-line-length
                , { 
                    // tslint:disable-next-line:max-line-length
                    primaryText: PhoneEmailVerificationStrings_1["default"].beforeProceedingVerify() })))))));
};
exports["default"] = PhoneEmailVerifyContent;
